import { Descriptions, Drawer, Typography } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

interface Props {
  open: boolean
  onClose: () => void
  thresholds?: Record<string, string | number | null>
  versions?: Record<string, string>
}

// "How performance is calculated" (spec §7 Auditability): the formulas in words,
// with the live thresholds and score versions the server applied.
export function CalculationHelp({
  open,
  onClose,
  thresholds = {},
  versions = {}
}: Props) {
  const { t } = useTranslation()
  const sections = [
    "eligibility",
    "periods",
    "schedule",
    "financial",
    "scheduleScore",
    "financialScore",
    "status",
    "limits"
  ]
  return (
    <Drawer
      open={open}
      onClose={onClose}
      width={560}
      title={t("teamPerformance.help.title")}
    >
      {sections.map((section) => (
        <div key={section} className="mb-4">
          <Typography.Title level={5}>
            {t(`teamPerformance.help.${section}.title`)}
          </Typography.Title>
          <Typography.Paragraph className="whitespace-pre-line">
            {t(`teamPerformance.help.${section}.body`, {
              grace: thresholds.grace_days ?? 0,
              severe: thresholds.severe_project_days ?? 14,
              over: thresholds.late_over_days ?? 7,
              milestone: thresholds.severe_milestone_days ?? 7,
              sample: thresholds.min_score_sample ?? 3,
              company: thresholds.min_benchmark_company ?? 5,
              attention: thresholds.attention_below ?? 70,
              good: thresholds.good_at_least ?? 85,
              watchTop: Number(thresholds.good_at_least ?? 85) - 1,
              tolerance: thresholds.currency_tolerance ?? "1.00"
            })}
          </Typography.Paragraph>
        </div>
      ))}
      <Descriptions
        size="small"
        column={1}
        title={t("teamPerformance.help.versions")}
        items={Object.entries(versions).map(([k, v]) => ({
          key: k,
          label: k,
          children: v
        }))}
      />
    </Drawer>
  )
}
